// import Vue from 'vue'
import {
  UPDATE_APP_STEP,
  UPDATE_USER_LANGUAGE,
  UPDATE_APP_INIT,
  UPDATE_TOOLBAR_TITLE,
  UPDATE_APP_READY,
  ENQUEUE_SNACKBAR,
  DEQUEUE_SNACKBAR,
  UPDATE_AVAILABLE_LANGUAGES,
  UPDATE_USER_LOGIN_INFO,
  REMOVE_USER_LOGIN_INFO,
  UPDATE_USER_OBJECT,
  UPDATE_USER_CHILDREN,
  UPDATE_ASSESSMENTS
} from './mutation-types'
import { lsSetItem, lsRemoveItem, dateDiff } from './functions'
import { ASS_OPEN_FOR_AGE_RANGE } from '@/constants'

export function isAssessmentOpen (age, assType) {
  const {min, max} = ASS_OPEN_FOR_AGE_RANGE[assType]
  return min <= age && age <= max
}

const mutations = {
  [UPDATE_APP_INIT] (state, appInit) {
    state.appInit = appInit
  },
  [UPDATE_APP_READY] (state, appReady) {
    state.appReady = appReady
  },
  [UPDATE_APP_STEP] (state, step) {
    state.appStep = step
  },
  [UPDATE_TOOLBAR_TITLE] (state, title) {
    state.appToolbarTitle = title
  },
  [UPDATE_USER_LANGUAGE] (state, lang) {
    state.userSelectedLang = lang
    lsSetItem('userSelectedLang', state.userSelectedLang)
  },
  [ENQUEUE_SNACKBAR] (state, config) {
    state.snackbarQueue.push(config)
  },
  [DEQUEUE_SNACKBAR] (state) {
    state.snackbarQueue.shift()
  },
  [UPDATE_USER_OBJECT] (state, data) {
    state.userObject = {
      email: data.email,
      firstName: data.firstName,
      lastName: data.lastName
    }

    lsSetItem('userObject', state.userObject)
  },
  [UPDATE_USER_LOGIN_INFO] (state, data) {
    state.userToken = data.token
    state.userObject = {
      email: data.email,
      firstName: data.firstName,
      lastName: data.lastName
    }

    lsSetItem('userToken', state.userToken)
    lsSetItem('userObject', state.userObject)
  },
  [REMOVE_USER_LOGIN_INFO] (state) {
    state.userToken = null
    state.userObject = null

    lsRemoveItem('userToken')
    lsRemoveItem('userObject')
  },
  [UPDATE_USER_CHILDREN] (state, {childList, assessmentList}) {
    // TODO data transforming logic below should be moved out of mutation step
    // better do it in actions
    const completedAssList = {}
    const assTypeMap = {
      '12-Month': 12,
      '18-Month': 18,
      '24-Month': 24
    }

    console.log('childList', childList, 'assessmentList', assessmentList)

    assessmentList.forEach((ass) => {
      if (ass.assessment.key) {
        const childId = ass.child.id
        const assType = ass.assessment.eligibleAge

        const assessment = {
          childId,
          atRisk: ass.atRisk,
          original: ass
        }

        if (!completedAssList[childId]) {
          completedAssList[childId] = {}
        }

        if (!completedAssList[childId][assType]) {
          completedAssList[childId][assType] = {}
        }

        completedAssList[childId][assType] = assessment
      }
    })

    const updatedChildList = []

    childList.forEach((rawChildData) => {
      const birthDate = new Date(rawChildData.birthDate * 1000)
      const child = {
        id: rawChildData.id,
        initials: rawChildData.initials,
        firstName: rawChildData.firstName,
        lastName: rawChildData.lastName,
        birthDate: birthDate,
        totalMonthsOld: rawChildData.totalMonthsOld ||
          dateDiff(new Date(), birthDate).getTotalMonths(),
        gender: rawChildData.gender,
        currentlyAtRisk: rawChildData.currentlyAtRisk,
        everAtRisk: rawChildData.everAtRisk,
        assessmentStatuses: {},
        assessments: {}
      }

      Object.values(assTypeMap).forEach((type) => {
        // child.assessments[type] = child.totalMonthsOld === type ? 0 : -1
        child.assessmentStatuses[type] = isAssessmentOpen(child.totalMonthsOld, type) ? 0 : -1
        child.assessments[type] = null
        if (completedAssList[child.id] && completedAssList[child.id][type]) {
          const assResult = completedAssList[child.id][type]
          child.assessmentStatuses[type] = assResult.atRisk ? 2 : 1
          child.assessments[type] = assResult
        }
      })

      updatedChildList.push(child)
    })

    state.userChildren.splice(0, state.userChildren.length, ...updatedChildList)
  },
  [UPDATE_ASSESSMENTS] (state, assessments) {
    state.assessments = Object.assign({}, assessments)
  },
  [UPDATE_AVAILABLE_LANGUAGES] (state, newLanguages) {
    state.availableLangs.splice(0, state.availableLangs.length, ...newLanguages)
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js